import React, {useEffect, useState} from "react";
import {MdOutlineRefresh} from "react-icons/md";
import {submitReport} from "@/services/apiUsers";
import {DIST_ID, DIST_BUILD, BUILD_TYPE} from "@/constants/app.constant";
import {useLocation} from "react-router-dom";
import Button from "@/components/ui/Button";
import Logo from "@/components/template/Logo";
import useAuth from "@/utils/hooks/useAuth";
import NL2BR from "@/components/ui/NL2BR";

const ErrorBoundary = ({children}) => {
    // const user = useAppSelector(state => state.auth.user)
    // const role = useAppSelector(state => state.auth.role)
    const {user} = useAuth()

    const location = useLocation();
    const [error, setError] = useState(null);
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        if (error == null) return;

        submitReport({
            title: "خطای نرم‌افزاری",
            message: "خطای نرم‌افزاری در نسخه وب",
            contentType: null,
            contentId: null,
            details: {
                user: user?.id,
                app: DIST_ID,
                app_version: DIST_BUILD,
                url: location.href,
                error,
            },
        });
    }, [error]);

    useEffect(() => {
        const handleError = (error, errorInfo) => {
            try {
                setHasError(true);
                setError(errorInfo.componentStack);

                console.error(error);
                // console.error(errorInfo);
            } catch (e) {

            }
        };

        // Listen for errors in the children components
        const onError = (event) => {
            handleError(event.error, {componentStack: event.error.stack});
        };

        window.addEventListener("error", onError);

        return () => {
            window.removeEventListener("error", onError);
        };
    }, []);


    if (hasError) {
        return <div className="flex flex-auto flex-col h-[100vh] mx-4 justify-center items-center gap-4">
            <Logo className={"h-[50px]"}/>
            <b className={"mt-7 text-xl"}>متاسفیم! </b>
            <p className={"font-medium text-base text-center"}>
                خطای غیر منتظره‌ای پیش آمده! لطفا مجددا تلاش کنید!
            </p>
            {(BUILD_TYPE == 0
                // || role?.permissions?.includes("*")
            ) && <div className={"text-xs bg-gray-300 dark:bg-gray-900 p-4 rounded-xl overflow-y-overlay max-h-[300px]"} dir={"ltr"}>
                <NL2BR>{error}</NL2BR>
            </div>}
            <Button size="large" variant={"solid"} onClick={() => window.location.reload()} icon={<MdOutlineRefresh/>}> تلاش مجدد </Button>
        </div>
    }

    return children;
};

export default ErrorBoundary;
